import React from "react";
import BaseDialog from "components/BaseDialog";
import {useMessages} from "i18n";
import {CloseX, DialogBody, narrowGutterSx} from "./ClosableDialog.styles";

interface Props {
	title: string;
	open: boolean;
	onClose: () => void;
	/**
	 * On a phone, keep only the page's own gutter around the paper instead of MUI's wider margin: for content
	 * drawn at a fixed width that the default paper would squeeze, the coupon ticket (kitecorp/transferify-ui#3343).
	 */
	narrowGutter?: boolean;
	children?: React.ReactNode;
}

/**
 * A {@link BaseDialog} with a title, a ✕ in its top-right corner and a padded body: the transfer row's link and
 * QR dialog (ticket #32), the live card's "Show QR code" (kitecorp/transferify-ui#3320) and the success cards'
 * coupon (kitecorp/transferify-ui#3343). The ✕ is the touch device's way out next to the scrim; Escape works as in
 * every dialog.
 */
export function ClosableDialog({title, open, onClose, narrowGutter = false, children}: Props) {
	const {common} = useMessages();
	return (
		<BaseDialog title={title} open={open} onClose={onClose} sx={narrowGutter ? narrowGutterSx : undefined}>
			<CloseX type="button" aria-label={common.close} onClick={onClose}>
				<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
					strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
					<path d="M6 6l12 12"/>
					<path d="M18 6L6 18"/>
				</svg>
			</CloseX>
			<DialogBody>{children}</DialogBody>
		</BaseDialog>
	);
}
